import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private _auth = inject(AuthService);
  private _router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const token = localStorage.getItem('token');

    // If token is valid, allow access
    if (token && !this.isTokenExpired(token)) {
      return true;
    }

    // If token is missing or expired, try to refresh
    const refreshed = await this._auth.refreshToken();

    if (refreshed) {
      return true;
    }

    this._auth.logout();
    this._router.navigate(['/']);
    return false;
  }

  private isTokenExpired(token: string): boolean {
    try {
      const decoded: any = jwtDecode(token);
      return decoded.exp * 1000 < Date.now();
    } catch (error) {
      return true;
    }
  }
}
